import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { HttpClient } from './http-client.service';

import { Goal, FiscalYear } from '../../entities';

import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

@Injectable()
export class GoalService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly goalBaseUrl:string = `${Settings.apiUrl}/v1/Goals`;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getGoals(fiscalYear: FiscalYear): Promise<Goal[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(GoalService.goalBaseUrl);

    oDataBuilder.filter("EndDate", ODataComparer.GreaterThanOrEqual, fiscalYear.EndDate)
      .filter("StartDate", ODataComparer.LessThanOrEqual, fiscalYear.EndDate)
      .expand("GoalCategory")
      .expand("GoalType")
      .orderBy("GoalCategory/SortOrder")
      .orderBy("SortOrder");

    let goalUrl: string = oDataBuilder.toString();

    return this.http.get(goalUrl)
      .toPromise()
      .then(response => response.json().value);
  }

  getGoalCountByGoalCategoryId(goalCategoryId: string): Promise<number> {
    let oDataBuilder: ODataBuilder = new ODataBuilder(GoalService.goalBaseUrl);

    let goalUrl:string = `${GoalService.goalBaseUrl}/?$filter=GoalCategoryId eq ${goalCategoryId}&$top=0&$count=true`;

    return this.http.get(goalUrl)
      .toPromise()
      .then(response => {
        return response.json()['@odata.count'];
      });
  }

  createGoal(goal: Goal): Promise<Goal> {
    let goalUrl: string = `${Settings.apiUrl}/v1/Goals`;
    
    // must remove - breaks deserialization on the server when trying to convert empty string to Guid 
    delete goal.GoalId;

    return this.http.post(goalUrl, JSON.stringify(goal), this.options)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  patchGoal(goal: Goal): Promise<null> {

    let goalUrl: string = `${Settings.apiUrl}/v1/Goals(${goal.GoalId})`;

    return this.http.patch(goalUrl, JSON.stringify(goal), this.options)
      .toPromise()
      .then(response => response);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/goal.service.ts